import React from 'react'

export const NotFound404 = () => {
  return (
    <div>404-notfound</div>
  )
}
